import React from 'react';
import { graphql } from 'gatsby';
import Sign from '../components/sign'
import Layout from "../components/layout"
import SEO from "../components/seo"
import BreadcrumbJsonLd from "../components/breadcrumb-jsonld"
import { isFreshDaily } from "../utils/fresh"
import {
  Section,
  Content,
} from "bloomer"
import OutrosJogos from "../components/outros-jogos"

const capitalize = s => s.charAt(0) + s.slice(1).toLowerCase()

// Horóscopo del día: JSON generado a diario por site_horoscope_job.py (repo lua).
// Se resuelve en build time → queda en el HTML estático, indexable.
const dailyFor = mname => {
  try {
    return require(`../data/horoscopo-diario/${mname}.json`)
  } catch (e) {
    return null
  }
}

// Frase do dia por signo (pack de identificación, generada a diario).
const fraseFor = mname => {
  try {
    return require(`../data/frase-do-dia/${mname}.json`)
  } catch (e) {
    return null
  }
}

const fmtDate = iso => {
  const [y, m, d] = iso.split("-")
  return `${d}/${m}/${y}`
}

export default ({ data }) => {
  //const post = data.markdownRemark;
  const { markdownRemark } = data // data.markdownRemark holds your post data
  const { frontmatter, html } = markdownRemark
  // Solo se muestran si el generador corrió hoy/ayer: nunca un 'horóscopo do dia' viejo.
  const dailyRaw = dailyFor(frontmatter.mname)
  const daily = dailyRaw && isFreshDaily(dailyRaw.date) ? dailyRaw : null
  const fraseRaw = fraseFor(frontmatter.mname)
  const frase = fraseRaw && isFreshDaily(fraseRaw.date) ? fraseRaw : null
  return (
    <Layout>
        <SEO
          title={`Horóscopo ${capitalize(frontmatter.name)}: datas, personalidade e amor | EstrelaGuia`}
          description={`${capitalize(frontmatter.name)} (${frontmatter.dates}): regente ${frontmatter.regente}, elemento ${frontmatter.elemento}. Perfil completo do signo — personalidade, amor e trabalho.`}
          pathname={`/horoscopo/${frontmatter.mname}/`}
          image={`/og/horoscopo-${String(frontmatter.mname).trim()}.png`}
        />
        <BreadcrumbJsonLd trail={[
          { name: "Início", path: "/" },
          { name: "Horóscopo", path: "/horoscopo/" },
          { name: capitalize(frontmatter.name), path: `/horoscopo/${frontmatter.mname}/` },
        ]} />
        <article>
          <header className="content">          
            {/* <Sign icon={frontmatter.mname} title={frontmatter.name}></Sign> */}
            <h1 className="title is-2">{frontmatter.name}</h1>
            <h2 className="subtitle is-5">{frontmatter.dates}</h2>
            <div><strong>Regente:</strong> {frontmatter.regente}</div>
            <div><strong>Cor:</strong> {frontmatter.cor}</div>
            <div><strong>Elemento:</strong> {frontmatter.elemento}</div>
          </header>
          {frase && (
            <Content className="frase-do-dia">
              <span className="frase-do-dia-label">Frase do dia 🌙</span>
              <p>{frase.frase}</p>
            </Content>
          )}
          {daily && (
            <Content className="horoscopo-do-dia">
              <h2 className="title is-4">Horóscopo do dia — {fmtDate(daily.date)}</h2>
              <p>{daily.text}</p>
            </Content>
          )}
          <Content dangerouslySetInnerHTML={{ __html: html }}/>
          <OutrosJogos atual="/horoscopo/" />
          </article>
    </Layout> 
  );

};

export const query = graphql`
  query($slug: String!) {
    markdownRemark(fields: { slug: { eq: $slug } }) {
      frontmatter {
        name
        dates
        regente
        cor
        elemento
        mname
      }
      html
    }
  }
`;